import type { DrawingDocument } from "../types";
import { createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "drawings";

export const drawingsColumns = [
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.id",
        header: "Drawing No",
    }),
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.Title",
        header: "Drawing Title",
    }),
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.Revision",
        header: "Revision",
    }),
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.links.Machine No",
        header: "Machine No",
    }),
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.links.Equipment",
        header: "Equipment",
    }),
    createStringColumn<DrawingDocument>({
        namespace,
        field: "metadata.Product Line",
        header: "Product Line",
    }),
    createLinkColumn<DrawingDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
        accessor: (row) => row.fields?.source ?? "N/A",
    }),
];
